document.querySelectorAll('.accordionp .accordionp-title').forEach(button => {
  button.addEventListener('click', () => {
    // This will toggle the accordionp
    const accordionContent = button.nextElementSibling;
    accordionContent.style.display = accordionContent.style.display === 'block' ? 'none' : 'block';
  });
});
